import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getPeriodByKey } from '../../../constants/shared/PMConstants';
import Button from '../../../components/button/Button';
import { generateReactKey } from '../../../utils/shared/commonUtils';

const TimeFrameButtons = ({
    periods,
    currentPeriod,
    selectedPeriod,
    onPeriodClick,
    labelClassNames,
    buttonClassNames,
}) => {
    const [period, setPeriod] = useState(selectedPeriod);
    const currentPeriodIndex = periods.indexOf(getPeriodByKey(periods, currentPeriod));

    useEffect(() => {
        setPeriod(selectedPeriod);
    }, [selectedPeriod]);

    return (
        <div className="time-frame">
            <div className={labelClassNames}>Time frame</div>
            {periods.map(({ key, title }, index) => (
                <Button
                    key={generateReactKey(key)}
                    className={`btn ${buttonClassNames} ${key === period ? '' : 'unselected'}`}
                    text={title}
                    isDisabled={index > currentPeriodIndex}
                    onClick={() => {
                        setPeriod(key);
                        onPeriodClick(key);
                    }}
                />
            ))}
        </div>
    );
};

TimeFrameButtons.defaultProps = {
    periods: [],
    currentPeriod: null,
    selectedPeriod: null,
    onPeriodClick: () => {},
    labelClassNames: '',
    buttonClassNames: '',
};

TimeFrameButtons.propTypes = {
    periods: PropTypes.arrayOf(PropTypes.object),
    currentPeriod: PropTypes.string,
    selectedPeriod: PropTypes.string,
    onPeriodClick: PropTypes.func,
    labelClassNames: PropTypes.string,
    buttonClassNames: PropTypes.string,
};

export default TimeFrameButtons;
